import React from 'react';
import PropTypes from 'prop-types';

import connectStore from 'decorators/connectStore';
import provideTranslations from 'decorators/provideTranslations';

import IdentityActionCreator from 'actions/IdentityActionCreator';
import IdentityStore from 'stores/IdentityStore';

import NotificationBanner from 'components/shared/NotificationBanner';

@provideTranslations('Core')
@connectStore(IdentityStore, 'identityState')
class IdentityStatusContainer extends React.Component {
  render() {
    return <IdentityStatus {...this.props} />;
  }
}

class IdentityStatus extends React.Component {
  static propTypes = {
    identityState: PropTypes.object.isRequired,
    pollingInterval: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  static defaultProps = {
    pollingInterval: 5000,
  };

  static Icon = {
    spinner: 'SPINNER',
    pending: 'PENDING',
    success: 'SUCCESS',
  }

  constructor(props) {
    super(props);
    this.interval = null;
    this.startPollingIdentity = this.startPollingIdentity.bind(this);
    this.stopPollingIdentity = this.stopPollingIdentity.bind(this);
    this.sendToConfirm = this.sendToConfirm.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  componentDidMount() {
    const identity = this.props.identityState.currentIdentity;
    const state = identity ? identity.state : null;
    const pollingStates = [
      IdentityStore.IDENTITY_STATE.PENDING_VERIFICATION,
      IdentityStore.IDENTITY_STATE.PENDING_UPDATE_IRIDIUM,
      IdentityStore.IDENTITY_STATE.PENDING_ASIN,
    ];

    if (pollingStates.includes(state)) {
      this.startPollingIdentity();
    } else {
      this.stopPollingIdentity();
    }
  }

  shouldComponentUpdate(nextProps) {
    const lastIdentity = this.props.identityState.currentIdentity;
    const nextIdentity = nextProps.identityState.currentIdentity;

    // Don't update if the current identity has not changed or has not changed state
    if ((lastIdentity !== undefined && nextIdentity !== undefined)
        && lastIdentity.amazonAuthorId === nextIdentity.amazonAuthorId
        && lastIdentity.state === nextIdentity.state
        && lastIdentity.isAcknowledged === false) {
      return false;
    }

    return true;
  }

  componentWillUnmount() {
    this.stopPollingIdentity();
  }

  handleDismiss(e) {
    e.preventDefault();
    IdentityActionCreator.acknowledge(this.props.identityState.currentIdentity.amazonAuthorId);
  }

  startPollingIdentity() {
    this.interval = setInterval(() => {
      IdentityActionCreator.fetch();
    }, this.props.pollingInterval);
  }

  stopPollingIdentity() {
    if (this.interval) {
      clearTimeout(this.interval);
    }
  }

  sendToConfirm() {
    const { router } = this.context;
    router.push({ pathname: '/claim/confirm' });
  }

  render() {
    const { getString } = this.context;
    const identity = this.props.identityState.currentIdentity;
    const state = identity ? identity.state : null;

    // TODO: Remove all unused if blocks after we backfill from RDS and remove unused pending state.
    if (state === IdentityStore.IDENTITY_STATE.PENDING_MANUAL_APPROVAL) {
      this.stopPollingIdentity();
      return (
        // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
        <NotificationBanner
          iconType={NotificationBanner.IconTypes.pending}
          titleString={getString('AA_Account_Pending_Verification')}
          dangerouslySetTextString={getString('AA_Account_Pending_Process')}
        />
      );
    } if (state === IdentityStore.IDENTITY_STATE.PENDING) {
      this.stopPollingIdentity();
      return (
        // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
        // TODO: This is not the final string copy, the string will be updated in another task.
        <NotificationBanner
          iconType={NotificationBanner.IconTypes.pending}
          titleString={getString('AA_Verify_Your_Identity')}
          dangerouslySetTextString={getString('AA_Provide_Government_ID')}
        />
      );
    } if (state === IdentityStore.IDENTITY_STATE.PENDING_GOVERNMENT_ID) {
      this.stopPollingIdentity();
      // TODO Redirect to government ID upload page instead of showing this banner
      return (
        // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
        <NotificationBanner
          iconType={NotificationBanner.IconTypes.pending}
          titleString={getString('AA_Verify_Your_Identity')}
          dangerouslySetTextString={getString('AA_Provide_Government_ID')}
        />
      );
    } if (state === IdentityStore.IDENTITY_STATE.PENDING_CONFIRM_IDENTITY) {
      this.stopPollingIdentity();
      return (
        // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
        <NotificationBanner
          iconType={NotificationBanner.IconTypes.pending}
          onClick={this.sendToConfirm}
          titleString={getString('AA_Are_You_Author_Name', { authorName: identity.claimedAuthorName })}
          dangerouslySetTextString={getString('AA_Account_Name_Mismatch_Click_Here')}
        />
      );
    } if (state === IdentityStore.IDENTITY_STATE.PENDING_ASIN) {
      return (
        // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
        <NotificationBanner
          iconType={NotificationBanner.IconTypes.spinner}
          titleString={getString('AA_Building_Author_Page')}
          dangerouslySetTextString={getString('AA_Account_Pending_Asin_Process')}
        />
      );
    } if (state !== IdentityStore.IDENTITY_STATE.APPROVED && state !== null) {
      return (
        // Do not pass in user input because of XSS risks with dangerouslySetInnerHTML
        <NotificationBanner
          iconType={NotificationBanner.IconTypes.spinner}
          dangerouslySetTextString={getString('AA_Setting_Up_Account')}
        />
      );
    }

    return null;
  }
}

export default IdentityStatusContainer;
